export const IsLocalEnvironment = (): boolean => {
    return /^(localhost|127\.0\.0\.1)/.test(window.location.hostname);
};
